import React from 'react';
import '../Process/Processbox.css';




function Processbox(props) {
  return (
    <div className='processbox'>
        <img src={props.img} />
        <div className='text-section'>
            <h5>{props.h5}</h5>
            <span id='span'>{props.text}</span>
        </div>
    </div>
  )
}

export default Processbox